import {useHttp} from '@/core/http'
import {useToken} from '@/core/utils/token'

const tokenHelper = useToken()

export const useAuthService = () => {

    const logout = (): boolean => {
        let status = false

        useHttp().post('auth/logout')
            .finally(() => {
                status = tokenHelper.clearToken()
            })

        return status
    }

    const getUser = <T>(): Promise<T> => {
        return new Promise<T>((resolve, reject) => {
            useHttp()
                .get('auth/user')
                .then((data: any) => {
                    resolve(data as T)
                })
                .catch((response: any) => {
                    tokenHelper.clearToken()
                    reject(response as T)
                })
        })
    }

    return {
        getUser,
        logout
    }
}
